const getIdFromUrl = (url) => {
  if (/youtu\.?be/.test(url)) {
    const patterns = [
      /youtu\.be\/([^#&?]{11})/, // youtu.be/<id>
      /\?v=([^#&?]{11})/, // ?v=<id>
      /&v=([^#&?]{11})/, // &v=<id>
      /embed\/([^#&?]{11})/, // embed/<id>
      /\/v\/([^#&?]{11})/ // /v/<id>
    ]

    for (let i = 0; i < patterns.length; ++i) {
      if (patterns[i].test(url)) {
        return patterns[i].exec(url)[1]
      }
    }
  }

  if (/^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/.test(url)) {
    const parseURL = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/.exec(url)
    return parseURL[5]
  }
  return null
}

function init (el) {
  const selectors = {
    TRIGGER_PLAY_PAUSE_SELECTOR: '.js-play-pause-video',
    VIDEO_THUMBNAIL_SELECTOR: '.js-video-thumbnail'
  }
  const classes = {
    PLAYING_CLASS: 'is-playing',
    PAUSE_CLASS: 'is-paused',
    ACTIVE_CLASS: 'is-active'
  }
  let player
  const status = {
    play: false,
    pause: true
  }

  const settings = JSON.parse(el.getAttribute('data-settings'))
  const options = {
    videoId: settings.videoType !== 'mp4' && getIdFromUrl(settings.videoUrl),
    ...settings
  }

  const data = {
    type: options.videoType,
    element: el
  }

  const playPauseTriggerEl = el.querySelector(selectors.TRIGGER_PLAY_PAUSE_SELECTOR)
  const videoThumbnailEl = el.querySelector(selectors.VIDEO_THUMBNAIL_SELECTOR)

  const play = () => {
    if (options.videoType !== 'youtube') {
      player.play()
    } else player.playVideo()

    el.classList.add(classes.PLAYING_CLASS)
    el.classList.remove(classes.PAUSE_CLASS)
    status.play = true
    status.pause = false

    document.dispatchEvent(new window.CustomEvent('videoManagement:play', {
      detail: {
        player,
        ...data
      }
    }))

    videoThumbnailEl.classList.add(classes.ACTIVE_CLASS)
  }

  const pause = () => {
    if (options.videoType !== 'youtube') {
      player.pause()
    } else player.pauseVideo()

    status.play = false
    status.pause = true

    el.classList.remove(classes.PLAYING_CLASS)
    el.classList.add(classes.PAUSE_CLASS)
    videoThumbnailEl.classList.remove(classes.ACTIVE_CLASS)
  }

  const loadScript = () => {
    return new Promise(function (resolve, reject) {
      let url = ''
      if (!window.YT || !window.Vimeo) {
        if (!window.YT && options.videoType === 'youtube') url = '//www.youtube.com/iframe_api'
        else if (!window.Vimeo && options.videoType === 'vimeo') url = '//player.vimeo.com/api/player.js'
        const script = document.createElement('script')
        document.body.appendChild(script)
        script.onload = resolve
        script.onerror = reject
        script.async = true
        script.src = url
      } else resolve()
    })
  }

  const setupPlayer = () => {
    const elementToInsert = el.querySelector('.js-video')

    const playerLoadingInterval = setInterval(function () {
      if (options['videoType'] === 'youtube') {
        if (window.YT) {
          player = new window.YT.Player(elementToInsert, {
            videoId: options['videoId'],
            playerVars: {
              showinfo: 0,
              controls: 0,
              fs: 0,
              rel: 0,
              height: '100%',
              width: '100%',
              iv_load_policy: 3,
              html5: 1,
              loop: 1,
              playsinline: 1,
              modestbranding: 1,
              disablekb: 1,
              origin: options['requestHost']
            },
            events: {
              onReady: _onYouTubeReady,
              onStateChange: _onYouTubeStateChange
            }
          })

          clearInterval(playerLoadingInterval)
        }
      } else if (options.videoType === 'vimeo') {
        if (window.Vimeo) {
          player = new window.Vimeo.Player(elementToInsert, {
            id: options['videoId'],
            controls: false
          })
          clearInterval(playerLoadingInterval)
        }
      }
      if (player) {
        document.dispatchEvent(new window.CustomEvent('videoManagement:player', {
          detail: { ...data, player }
        }))
      }
    }, 50)
  }

  const setupPlayerMP4 = () => {
    return new Promise((resolve) => {
      player = el.querySelector('.js-video')
      if (player) {
        document.dispatchEvent(new window.CustomEvent('videoManagement:player', {
          detail: { ...data, player }
        }))
        resolve()
      }
    })
  }

  const _onYouTubeReady = (e) => {
    player.mute()
  }

  const _onYouTubeStateChange = (event) => {
    if (event.data === window.YT.PlayerState.ENDED) {
      this.player.playVideo()
    }
  }

  el.addEventListener('video:play', play)
  el.addEventListener('video:pause', pause)

  if (options.videoType !== 'mp4') {
    loadScript().then(setupPlayer()).then(() => {
      playPauseTriggerEl.addEventListener('click', () => {
        if (status.play) pause()
        else play()
      })
    })
  } else {
    setupPlayerMP4().then(() => {
      playPauseTriggerEl.addEventListener('click', () => {
        if (status.play) pause()
        else play()
      })
    })
  }
}


const videos = document.querySelectorAll('[data-module-init="video"]')

videos.forEach((video) => init(video))
